export default __webpack_public_path__ + "atomic/_patterns/01-atoms/primary-submenu-link/_primary-submenu-link.twig";